module.exports = __webpack_public_path__ + "./Kate_5aae72772b6e9eb2163dad2f364ba125.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Kate.jpg
// module id = 566
// module chunks = 0